import { Observable } from '../Observable';
export function isObservable(obj) {
  return !!obj && (obj instanceof Observable || typeof obj.lift === 'function' && typeof obj.subscribe === 'function');
}
